import React, {useState, useEffect, useMemo} from 'react';
import './index.scss';

import AttendanceTable from './components/table/table';
import SessionModal from './components/modal/sessionModal';
import Button from '../../../../../components/form/button/button';
import {
  getNewAttendance,
  clearAttendanceByDateData,
} from '../../../../../redux/risk-assessment-core/riskAssessmentCoreSlice';
import {useDispatch, useSelector} from 'react-redux';
import {getAttendanceData} from '../../../../../redux/selectors/riskAssessmentCore';
import UserModal from './components/modal/userModal/userModal';
import {getUsers} from '../../../../../redux/user-list/userListSlice';
import {useLocation, useNavigate} from 'react-router-dom';
import {getRiskAssessmentStateSelector} from '../../../../../redux/selectors/riskAssessment';
import {Badge, Tooltip} from '@mui/material';
import {getUserListSelector} from '../../../../../redux/selectors/userList';
import {crumbHref} from '../../utils/breadcrumb';
import {getFormattedTime, hoursToHoursMinutes} from '../../utils/helpers';
import {assets} from '../../../../../utils/assetsSrc';

const AttendanceTracker = () => {
  const nav = useNavigate();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const dispatch = useDispatch();
  const [attendance, setAttendance] = useState([]);
  const attendanceData = useSelector(getAttendanceData());

  const [isUserModalOpen, SetisUserModalOpen] = useState(false);

  const userListState = useSelector(getUserListSelector());

  const [riskAssessmentUsersTooltip, setRiskAssessmentUsersTooltip] = useState(
    [],
  );

  const location = useLocation();

  const raData = location?.state?.selectedRiskAssessment;


  const riskAssessmentId = raData?.id;

  // logic for risk assessment users
  const riskAssessments = useSelector(getRiskAssessmentStateSelector());

  const specificRiskAssessment = riskAssessments?.find(
    ra => ra?.id === riskAssessmentId,
  );

  const riskAssessmentUsers = specificRiskAssessment?.users || [];

  useEffect(() => {
    if (
      Array.isArray(userListState?.userList) &&
      Array.isArray(riskAssessmentUsers)
    ) {
      const formattedData = riskAssessmentUsers.map(item => {
        const itemData = userListState.userList.find(data => data.id === item);
        return itemData;
      });

      setRiskAssessmentUsersTooltip(formattedData);
    }
  }, [userListState, riskAssessmentUsers]);

  useEffect(() => {
    dispatch(
      getUsers({
        params: {
          search: '',
          size: null,
          page: null,
        },
      }),
    );
  }, []);

  useEffect(() => {
    if (attendanceData) {
      setAttendance(attendanceData);
    }
  }, [attendanceData]);

  useEffect(() => {
    if (riskAssessmentId) {
      dispatch(getNewAttendance({riskAssessmentId}));
    } else {
      nav(crumbHref['product-line']);
      return;
    }
  }, []);

  const handleModalOpen = () => setIsModalOpen(true);

  const handleModalClose = fromSave => {
    dispatch(clearAttendanceByDateData());
    setIsModalOpen(false);
    if (fromSave) dispatch(getNewAttendance({riskAssessmentId}));
  };

  const handleAddUserModalClose = fromSave => {
    dispatch(clearAttendanceByDateData());
    SetisUserModalOpen(false);
    if (fromSave) dispatch(getNewAttendance({riskAssessmentId}));
  };

  const totalDurationHours = useMemo(() => {
    return attendanceData.results?.reduce((acc, curr) => {
      return (acc += curr?.time);
    }, 0);
  }, [attendanceData.results]);

  return (
    <div className="attendence-layut-wrapper">
      <div className="attendance-header">
        <div className="header-back">
          <img
            onClick={() => {
              nav(-1);
            }}
            src={assets.backArrow}
          />
          <h3>Attendance Record</h3>
        </div>

        <div className="attendance-button">
          <Tooltip
            disableHoverListener={riskAssessmentUsersTooltip?.length === 0}
            title={
              <ul
                style={{
                  listStyleType: 'disc',
                  paddingLeft: '20px',
                  fontSize: '1rem',
                }}>
                {riskAssessmentUsersTooltip?.map((user, index) => (
                  <li key={index}>{user?.fullname}</li>
                ))}
              </ul>
            }>
            <Badge badgeContent={riskAssessmentUsers?.length} color="success">
              <Button
                variant="submit-button"
                clickHandler={() => SetisUserModalOpen(true)}>
                {'+ Add Users'}
              </Button>
            </Badge>
          </Tooltip>
          <Button variant="submit-button" clickHandler={handleModalOpen}>
            {'+ Session'}
          </Button>
        </div>
      </div>

      <div className="assessment-description">
        <span>Model: {raData?.machine_detail[0]?.name}</span>
        <span>Risk Assessment: {raData?.name}</span>
        <span>Total Hours: {getFormattedTime(totalDurationHours)}</span>
      </div>

      <div style={{paddingBottom: '50px'}}>
        <AttendanceTable
          riskAssessmentUsers={riskAssessmentUsersTooltip}
          data={attendance}
        />
      </div>

      {isModalOpen && (
        <SessionModal
          riskAssessmentUsers={riskAssessmentUsers}
          open={isModalOpen}
          onClose={handleModalClose}
        />
      )}

      {isUserModalOpen && (
        <UserModal open={isUserModalOpen} onClose={handleAddUserModalClose} />
      )}
    </div>
  );
};

export default AttendanceTracker;
